import { call, put, select } from 'redux-saga/effects';
import { selectNavStack, setCurrentState, setNavStack } from '../../../state/routeStack/routeStackSlice';
import { getNavigate } from '../../../services/router/router';

export default function* navStackBack() {
  const navigate = yield call(getNavigate);
  let stack = yield select(selectNavStack);
  stack = stack.slice(0, -1);
  const lastOnStack = stack[stack.length - 1];

  yield put(setCurrentState(lastOnStack));
  yield put(setNavStack(stack));
  navigate(lastOnStack.route, { state: lastOnStack.state });
}
